import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const WrapperLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  background: rgba(255, 255, 255, 0.6);

  width: 100%;
  height: 100%;

  z-index: 3;

  display: flex;
  align-items: center;
  justify-content: center;
`;
